<template>
  <div class="container">
    <a-spin :spinning="loading">
      <BackBtn :url='backUrl' :isFixed="true" @customBack="jumpList" />
      <FormCard>
        <div class="form-title">
          <FormPageHeader
            title="新增商品"
            :IconResource="Icon"
            :hideLine="true"
          />
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <div class="step-title">01 基础信息</div>
          <a-row>
            <a-col :span="16">
              <a-form-item label="商品名称">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入商品名称',
                          validator: validatorName,

                        },
                      ],
                    },
                  ]"
                  type="textarea"
                  :maxLength='maxlen'
                  auto-size
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item label="商品类型">
                <a-select
                  v-decorator="[
                    'type',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请选择商品类型',
                        },
                      ],
                    },
                  ]"
                >
                  <a-select-option
                    v-for="(item, key) in goodsType"
                    :value="item.value"
                    :key="key"
                    >{{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="商品属性">
                <a-select
                  v-decorator="[
                    'kind',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请选择商品属性',
                        },
                      ],
                    },
                  ]"
                >
                  <a-select-option
                    v-for="(item, key) in goodsKind"
                    :value="item.value"
                    :key="key"
                    >{{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="所需积分">
                <a-input-number
                  v-decorator="[
                    'score',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入所需积分',
                        },
                      ],
                    },
                  ]"
                  :min="1"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <div class="step-title">02 详细信息</div>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :labelAlign="'left'"
            label="商品描述"
          >
            <GoodsInfo
              v-decorator="[
                'details',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入商品描述',
                    },
                    { validator: validatorDetails, trigger: 'change' },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :labelAlign="'left'"
            name="banners"
            label="商品图片"
          >
            <GodsUploadImg
              v-decorator="[
                'banners',
                {
                  initialValue: [],
                  rules: [{ required: true, validator: validatorBanners }],
                },
              ]"
            />
          </a-form-item>
          <div class="step-title">03 规格库存设置</div>
          <a-form-item :colon="false">
            <span slot="label">
              <span class="attr-label-name">规格类型</span>
            </span>
            <a-radio-group v-model="type">
              <a-radio value="1"> 统一规格 </a-radio>
              <a-radio value="2"> 多种规格 </a-radio>
            </a-radio-group>
          </a-form-item>
          <div v-if="type === '1'">
            <a-form-item label="库存设置" :colon="false">
              <a-input-number
                style="width: 280px"
                :min="0"
                v-decorator="[
                  'specificationValue',
                  {
                    initialValue: 0,
                    rules: [
                      {
                        required: true,
                        message: '请输入库存设置',
                      },
                    ],
                  },
                ]"
              ></a-input-number>
            </a-form-item>
          </div>
          <div v-if="type === '2'">
            <a-form-item :colon="false" name="attr">
              <span slot="label">
                规格设置&nbsp;&nbsp;&nbsp;&nbsp;
                <span class="attr-label-text"
                  >规格属性添加后，点击“完成”按钮自动生成SKU表</span
                >
              </span>
              <GoodsSpecification
                :isEdit="isEdit"
                v-decorator="[
                  'attr',
                  {
                    initialValue: [
                      {
                        key: '',
                        value: [''],
                      },
                    ],
                    rules: [
                      {
                        required: true,
                        message: '请输入规格设置',
                      },
                      { validator: validatorAttr },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-popconfirm
              title="点击“完成”后，规格设置将不能修改，是否继续？"
              ok-text="是"
              cancel-text="否"
              @confirm="handleOk"
              v-if="isEdit"
            >
              <a-button type="primary">完成</a-button>
            </a-popconfirm>

            <a-form-item :colon="false" label="库存设置">
              <GoodsSKUTable
                v-decorator="[
                  'stocks',
                  {
                    initialValue: [],
                    rules: [
                      {
                        required: true,
                        message: '请输入库存设置',
                        validator: validatorStock,
                      },
                    ],
                  },
                ]"
                :columns="columns"
              />
            </a-form-item>
          </div>
          <FormPageFooter>
            <a-button style="width: 72px; margin-right: 10px" @click="jumpList"
              >取消</a-button
            >
            <a-button
              type="primary"
              style="width: 72px"
              @click="handleSubmit"
              :loading="loading"
              >发布</a-button
            >
          </FormPageFooter>
        </a-form>
      </FormCard>
      <!-- 返回提示 -->
      <Confirm
        :visible="tipVisible"
        @cancel="tipVisible = false"
        @ok="backToPage"
      >
        确认放弃本次编辑？
      </Confirm>
    </a-spin>
  </div>
</template>

<script>
import BackBtn from '@/components/BackBtn';
import FormCard from '@/components/FormCard';
import FormPageFooter from '@/components/FormPageFooter';
import FormPageHeader from '@/components/FormPageHeader';
import GoodsInfo from './components/GoodsInfo';
import GodsUploadImg from './components/GoodsUploadImg';
import GoodsSpecification from './components/GoodsSpecification';
import GoodsSKUTable from './components/GoodsSKUTable';
import Icon from '@/assets/goods/header.svg';
import { cartesianProductOf } from '@/utils/util';
import { goodsType, goodsKind, labelCol, wrapperCol } from '@/constants/goods';
import { addGoods } from '@/api/goods';
import { Confirm } from '@/components/';

export default {
  components: {
    BackBtn,
    FormCard,
    FormPageFooter,
    FormPageHeader,
    GoodsInfo,
    GodsUploadImg,
    GoodsSpecification,
    GoodsSKUTable,
    Confirm,
  },
  data() {
    return {
      backUrl: '/mall/goods/list',
      goodsKind,
      goodsType,
      Icon,
      wrapperCol,
      labelCol,
      type: '1',
      isEdit: true,
      form: this.$form.createForm(this, { name: 'form' }),
      columns: [],
      loading: false,
      maxlen: 20,
      tipVisible: false,
    };
  },
  methods: {
    validatorStock(_, value, callback) {
      if (!value) {
        callback(new Error('请输入库存设置'));
      }
      (value || []).forEach((item, i) => {
        if (item.number === null || item.number === undefined) {
          callback(new Error(`请输入第${i + 1}行的库存设置`));
        }
      });
      callback();
    },
    validatorAttr(_, value, callback) {
      if (!value) {
        return callback(new Error('请输入规格设置'));
      }
      const arr = [];
      (value || []).forEach((item) => {
        if (!item.key) callback(new Error('请输入规格名'));
        if (item.value.length === 0) callback(new Error('请添加属性值'));
        if (item.key.length > 10) callback(new Error('规格名请输入10字以内'));
        if (arr.indexOf(item.key) > -1) callback(new Error('规格名存在重复'));
        arr.push(item.key);
        const l = [];
        item.value.forEach((r) => {
          if (!r) callback(new Error('请输入属性值'));
          if (l.indexOf(r) > -1) callback(new Error('属性值存在重复'));
          if (r.length > 10) callback(new Error('属性值请输入10字以内'));
          l.push(r);
        });
      });
      callback();
    },
    validatorSpecificationValue(_, value, callback) {
      if (!value) {
        return callback(new Error('请输入库存设置'));
      }
      callback();
    },
    validatorBanners(_, value, callback) {
      if (!value) {
        return callback(new Error('请上传商品图片'));
      }
      // 判断是否有上传失败的
      let allUpload = true;
      let state = false;
      (value || []).forEach((item) => {
        if (item.isCover) {
          state = true;
        }
        if (!item.code) {
          allUpload = false;
        }
      });
      if (!allUpload) {
        callback(new Error('请选择500x500尺寸图片'));
      }
      if (!state) {
        return callback(new Error('请选择封面图'));
      }
      callback();
    },
    validatorDetails(_, value, callback) {
      console.log(value);
      // if (!value) return callback(new Error('请输入商品描述'));
      (value || []).forEach((item) => {
        if (item.kind === 'text' && !item.content) {
          return callback(new Error('请输入商品文字描述'));
        }
        if (item.kind === 'image' && !item.content && !item.code) {
          return callback(new Error('请上传商品图片'));
        }
      });
      callback();
    },
    validatorName(_, value, callback) {
      if (!value) {
        return callback(new Error('请输入商品名称'));
      }
      if (value.length > 20) return callback(new Error('请输入20字以内'));
      callback();
    },
    handleOk() {
      this.form.validateFields(['attr'], (error, value) => {
        if (error) return error;
        console.log(value);
        const newDataObj = {};
        const l = (value.attr || []).map((r, i) => {
          newDataObj[i] = r.key;
          return {
            dataIndex: r.key,
            title: r.key,
          };
        });
        const list = (value.attr || []).map((r) => r.value);
        const d = cartesianProductOf(...list);
        const data = d.map((item, i) => {
          const obj = {};
          item.forEach((r, i) => {
            const key = newDataObj[i];
            obj[key] = r;
            obj.number = 0;
          });
          return {
            ...obj,
            key: i,
          };
        });

        this.form.setFieldsValue({
          stocks: data,
        });
        this.isEdit = false;
        this.columns = [
          ...l,
          {
            title: '库存',
            width: 100,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ];
      });
    },
    handleSubmit() {
      const list = ['name', 'type', 'kind', 'details', 'score', 'banners'];
      const checkData =        this.type === '1'
        ? [...list, 'specificationValue']
        : [...list, 'attr', 'stocks'];
      this.form.validateFields(checkData, (error, value) => {
        if (error) return error;
        const data = {};
        let cover = {};
        const banners = (value.banners || []).map((r) => {
          if (r.isCover) {
            cover = {
              code: r.code,
              url: r.url,
            };
          }
          return {
            code: r.code,
            url: r.url,
          };
        });
        data.name = value.name;
        data.type = value.type;
        data.kind = value.kind;
        data.score = value.score;
        data.details = value.details;
        data.banners = banners;
        data.cover = cover;
        if (this.type === '1') {
          data.stocks = JSON.stringify([
            {
              number: value.specificationValue,
            },
          ]);
        } else {
          data.attr = value.attr;
          data.stocks = JSON.stringify((value.stocks || []).map((r) => {
            delete r.key;
            return r;
          }));
        }
        this.loading = true;
        addGoods({ ...data }).then((res) => {
          if (res) {
            this.loading = false;
            this.backToPage();
          }
        });
      });
    },
    // 是否填写判断
    isFill(obj) {
      let filled = false;
      try {
        Object.keys(obj).forEach((v) => {
          const val = obj[v];
          const type = typeof val;
          if ((type === 'string' || type === 'number') && val) {
            filled = true;
            throw 'end forEach';
          } else if (type === 'object') {
            if (Array.isArray(val)) {
              if (val.length !== 0) {
                filled = true;
                throw 'end forEach';
              }
            } else {
              filled = this.isFill(val);
            }
          }
        });
      } catch (e) {}
      return filled;
    },
    jumpList() {
      const value  = this.form.getFieldsValue();
      const filled = this.isFill(value);
      if (filled) { // 填写了数据
        this.tipVisible = true;
        return;
      }
      this.backToPage();
    },
    // 确认返回
    backToPage() {
      const { iframe } = this.$route.query;
      if (iframe) {
        this.$router.push({
          path: '/mall/goods/list',
          query: {
            iframe: '1',
          },
        });
        return;
      };
      this.$router.push({
        path: '/mall/goods/list',
      });
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.iframe) {
      this.backUrl = `${this.backUrl}?iframe=1`;
    }
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  overflow: auto;
}
.step-title {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #345fec;
  margin: 10px 0;
}
.form-title {
  margin-bottom: 24px;
}
.attr-label-text {
  font-size: 12px;
  color: #647494;
  line-height: 20px;
}
.attr-label-name::before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}
.ant-form-item{
  margin-bottom: 0;
}
.container /deep/ .ant-card-body{
  padding-bottom: 0;
}
</style>
